import { SpecialOfferProps } from '../types';
import {
    StyledSpecialOffer,
    ProductsBackground,
    StyledFrame,
    Product
} from './style';
import BundlePrice from '../../Bundles/BundlePrice';
import { EBundlesInternalViewModel } from '../../Helper/enums';
import { Box } from '@mui/system';
import {
    calculateSaleStrokedNumber,
    formattingNumber
} from '../../Helper/utils/utils';
import LocoBingoSaleBadge from '../../Badge/Sale/LocoBingoSaleBadge';

function SpecialOffer({
    price,
    productsList,
    availability,
    backgroundImage,
    backgroundColor,
    selectOffer,
    salePercentage = 0,
    amountBeforeSale,
    salePercentageDisplayType,
    isFree,
    productsQuantityFormat
}: SpecialOfferProps) {
    const AVAILABLE_TEXT = 'Available:';

    return (
        <StyledFrame onClick={selectOffer}>
            <StyledSpecialOffer
                backgroundImage={backgroundImage}
                backgroundColor={backgroundColor}
            >
                <div className="frame">
                    {salePercentage > 0 && (
                        <LocoBingoSaleBadge
                            salePercentage={salePercentage}
                            salePercentageDisplayType={
                                salePercentageDisplayType
                            }
                        />
                    )}
                    <div className="products__container">
                        <ProductsBackground>
                            {productsList.map((product, i) => {
                                return (
                                    <Product key={product.name} data={product}>
                                        <div className="image-container">
                                            <img
                                                src={product.images.product}
                                                alt="product"
                                                className="image"
                                            />
                                        </div>
                                        <div className="quantity-container">
                                            {salePercentage > 0 && i === 0 && (
                                                <p className="stroked">
                                                    {amountBeforeSale ??
                                                        `${formattingNumber(
                                                            calculateSaleStrokedNumber(
                                                                product.quantity,
                                                                salePercentage,
                                                                salePercentageDisplayType
                                                            ),
                                                            productsQuantityFormat
                                                        )}`}
                                                </p>
                                            )}
                                            <span className="products__quantity">
                                                {product.quantityDisplay}
                                            </span>
                                        </div>
                                    </Product>
                                );
                            })}
                        </ProductsBackground>
                    </div>
                    <Box className="price-container">
                        <BundlePrice
                            price={price}
                            type={EBundlesInternalViewModel.BAGLECODE}
                            availabilityText={AVAILABLE_TEXT}
                            availability={availability}
                            isFree={isFree}
                        />
                    </Box>
                </div>
            </StyledSpecialOffer>
        </StyledFrame>
    );
}

export default SpecialOffer;
